module.exports = __webpack_public_path__ + "static/media/hitachi.d54e0ead.png";